import Axios from '@/http'
export default {
  assignTaskDetail(params) {
    return new Promise((resolve, reject) => {
      Axios.post('taskAssign/assignTaskDetail', params).then((res) => {
        resolve(res)
      })
    })
  },
  todayTaskDetail(params) {
    return new Promise((resolve, reject) => {
      Axios.post('taskAssign/todayTaskDetail', params).then((res) => {
        resolve(res)
      })
    })
  },
  /* 任务情况V2（今日的任务执行情况） */
  todayTaskDetailv2(params) {
    return new Promise((resolve, reject) => {
      Axios.post('taskAssign/v2/todayTaskDetail', params).then((res) => {
        resolve(res)
      })
    })
  },
  updateStatus(params) {
    return new Promise((resolve, reject) => {
      Axios.post('taskAssign/updateStatus', params, { isJSON: false }).then(
        (res) => {
          resolve(res)
        }
      )
    })
  },

  /* 执行情况V2 */
  taskItemViewFn(params) {
    return new Promise((resolve, reject) => {
      Axios.post('taskAssign/v2/taskItemView', params).then((res) => {
        resolve(res)
      })
    })
  }
}
